export default __webpack_public_path__ + "static/media/co.650be7bf.svg";